import React from 'react';
import style from './index.scss';
import DrawerNotes from './drawerNotes';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { convertISOToDateTimeFormat } from '../../../../util/timezone';

import { orderBy, startCase } from '../../../../util/lodashlike';
const getColumnRender = (column, record, apiActions) => {
  switch (column.itemName) {
    case 'id':
      return (
        <div
          className={style.tableLink}
          onClick={() =>
            apiActions.navigateTo(
              `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig/${record.id}/view`
            )
          }>
          {record.id}
        </div>
      );
    case 'note':
      return (
        <div>
          <DrawerNotes data={record} />
        </div>
      );
    case 'status':
      if (record.status.toLowerCase() === 'in production')
        return <p className={style.successTag}>{startCase(record.status)}</p>;
      else
        return <p className={style.singleRecord}>{startCase(record.status)}</p>;
    case 'updatedAt':
      return <>{convertISOToDateTimeFormat(record.updatedAt)}</>;
    case '':
      return (
        <div>
          <FontAwesomeIcon
            title="Edit"
            onClick={() =>
              apiActions.navigateTo(
                `${ROUTE_AMLS_SMART_SCREENING}/matchingConfig/${record.id}/edit`
              )
            }
            icon={faEdit}
            style={{ fontSize: '16px', cursor: 'pointer' }}
            color="#748AA1"
          />
        </div>
      );
  }
  return null;
};

export const parseColumnsForMatchingConfigListing = (settings, apiActions) => {
  let columns = null;
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );
    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (getColumnRender(column, record, apiActions) !== null)
                  return getColumnRender(column, record, apiActions);
                else if (setting.columnDetail.length >= 2)
                  return (
                    <p key={idx} className={style.mutliRecord}>
                      {record[column.itemName]}
                    </p>
                  );
                else
                  return (
                    <p key={idx} className={style.singleRecord}>
                      {record[column.itemName]}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};
